<div class="item-arrow">
  <div class="item-arrow-wrapper">
    <img src="/assets/img/right-arrow.svg" class="right-arrow" alt="Link arrow" />
  </div>
</div>
